import {
  Component,
  Input,
  ChangeDetectionStrategy,
  input,
  output
} from "@angular/core";

@Component({
  selector: "av-pager",
  templateUrl: "./pager.component.html",
  styleUrls: ["./pager.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PagerComponent {
  @Input()
  set totalPages(value: number) {
    this._totalPages = value;
    this.pages = [];
    for (let p = 0; p < this._totalPages; p++) {
      this.pages.push(p);
    }
  }
  get totalPages() {
    return this._totalPages;
  }

  readonly pageIndex = input(0);

  readonly pageChange = output<number>();

  pages: number[] = [];
  _totalPages: number;

  change(index: number) {
    this.pageChange.emit(index);
  }
}
